<script setup>
import { ref } from "vue";

const menu = ref();

const toggleMenu = (event) => {
    menu.value.toggle(event);
};

const items = ref([
    {
        label: 'Logout',
        icon: 'pi pi-sign-out',
        command: () => logout()
    }
]);

const user = inject('authenticatedUser');

import {axios} from '@/plugins/axios';
const logout = async () => {
    try {
        await axios.post('logout');
        window.location.href = '/login';
    } catch (e) {
        console.error(e);
    }
};
</script>

<template>
    <div>
        <Button link type="button" @click="toggleMenu" class="!text-white">
            {{ user.name }} <i class="pi pi-chevron-down"></i>
        </Button>
        <Menu ref="menu" :model="items" :popup="true" />
    </div>
</template>

